import { createContext, FC, useState } from 'react';
import {
  DATA_SOURCE_OVERRIDE_KEY,
  DataSourceOverride,
  getDataSourceOverride
} from 'src/utils/dataSource';

type DataSourceContextValue = {
  dataSourceOverride: DataSourceOverride;
  setDataSourceOverride: (value: DataSourceOverride) => void;
};

export const DataSourceContext = createContext<DataSourceContextValue>(
  {} as DataSourceContextValue
);

export const DataSourceProvider: FC = ({ children }) => {
  const [dataSourceOverride, setOverride] = useState<DataSourceOverride>(
    getDataSourceOverride()
  );

  // Reloads rather than refetching: every card has its own fetch and client cache, so a reload
  // is the one reliable way to make them all honor the new choice at once.
  const setDataSourceOverride = (value: DataSourceOverride) => {
    try {
      if (value === 'default')
        localStorage.removeItem(DATA_SOURCE_OVERRIDE_KEY);
      else localStorage.setItem(DATA_SOURCE_OVERRIDE_KEY, value);
    } catch {
      // Storage unavailable: keep the in-memory choice for this session.
    }
    setOverride(value);
    window.location.reload();
  };

  return (
    <DataSourceContext.Provider
      value={{ dataSourceOverride, setDataSourceOverride }}
    >
      {children}
    </DataSourceContext.Provider>
  );
};
